import React,{useEffect,useState} from 'react';
import { Route, Redirect } from "react-router-dom";
import { API, Auth } from 'aws-amplify';
import {Spinner} from 'grommet'

const ProtectedRoute = ({ component: Component, isUserAuthenticated, setUserRole, getOrgLogo,size, ...rest }) => {
    const [user, setUser] = useState()
    const [lab, setLab] = useState()
    const [username, setUserName] = useState()
    const [err, setErr] = useState()
    const [displayQuote, setDisplayQuote] = useState(false)
    const [load, setLoad] = useState(false)
    const ReturnComponent = (props) => {  
            if (isUserAuthenticated){
                if (props.location.pathname.includes('admin') && user === 'Agent') {
                    return <Redirect to='/shipment/new' {...props} user={user} username={username} displayQuote={displayQuote}/>
                  } else if  (props.location.pathname.includes('admin') && user !== 'SuperAdmin') {
                    return <Redirect to='/dashboard' {...props} user={user} username={username} displayQuote={displayQuote}/>
                } else if (props.location.pathname.includes('admin') && user === 'SuperAdmin'){
                    return <Component {...props} user={user} lab={lab} username={username} size={size} displayQuote={displayQuote} />
                }
                else {
                    return <Component {...props} user={user} lab={lab} username={username} size={size} displayQuote={displayQuote}/>
                }
            } else {
                return <Redirect to='/' {...props} user={user} username={username} size={size}  displayQuote={displayQuote} />
            }
    }
    useEffect(() => {     
            Auth.currentAuthenticatedUser().then(user => {
              setUser(user.signInUserSession.idToken.payload["cognito:groups"][0])
              setUserRole(user.signInUserSession.idToken.payload["cognito:groups"][0])
              setUserName(user.signInUserSession.idToken.payload['cognito:username'])
              sessionStorage.setItem("isUserAuthenticated", true)
              sessionStorage.setItem("token", user.signInUserSession.idToken.jwtToken.toString())
              sessionStorage.setItem("username", user.username.toString())
              sessionStorage.setItem("email", user.attributes.email.toString())
              setLoad(true)
            }).catch(err => {
                console.log(err)
                setErr(err)
                setLoad(true)
            })
            Auth.currentSession().then(session => {
                API
                .get("LabShip", "/set_origin_lab",{headers: { 
                    Authorization: session.idToken.jwtToken,
                  }})
                .then(
                (result) => {
                        setLab(result)
                        if(user === 'Customer'){
                            if (Array.isArray(result) && result.length > 0){
                                getOrgLogo(result[0].organisation_id)
                                setDisplayQuote(result[0].display_quote)
                            }
                        } else {
                            if (Array.isArray(result) && result.length > 0){
                                getOrgLogo(result[0].organisation_id)
                                setDisplayQuote(result[0].display_quote)
                            }
                        }
                      
                },
                (error) => {
                    setErr(error)
                    console.log(error);
                    console.log(err)
                }
                );
            })
      
       },[setUserRole,setDisplayQuote,user,getOrgLogo]);
    if (load){
        return (
            <Route {...rest} render={(props) => ReturnComponent(props)} />
            )
        } else {
           return <Spinner color='brand' size='medium' weight='bold' />

        }
    }

export default ProtectedRoute;